import type Icon from '@ant-design/icons';
import {
  red,
  volcano,
  orange,
  gold,
  yellow,
  lime,
  green,
  cyan,
  blue,
  geekblue,
  purple,
  magenta,
  grey,
} from '@ant-design/colors';

const colors = {
  red,
  volcano,
  orange,
  gold,
  yellow,
  lime,
  green,
  cyan,
  blue,
  geekblue,
  purple,
  magenta,
  grey,
};

export { colors };
export * from './icons';
export type { PalettesProps } from '@ant-design/colors';

export type ColorsPalette =
  | 'red'
  | 'volcano'
  | 'gold'
  | 'orange'
  | 'yellow'
  | 'lime'
  | 'green'
  | 'cyan'
  | 'blue'
  | 'geekblue'
  | 'purple'
  | 'magenta'
  | 'grey';

export type IconType = typeof Icon;
// TODO: deprecated export. Should be refactored
export * from '@ant-design/colors';
